// Imports del código nuevo (TypeScript)
import type { SideMenu } from '../../types/dashboard';
import type { PersonSecurityData } from '../../types/person';
import moment from 'moment';

// Imports del código viejo (jQuery)
import $ from 'jquery';
import CorgeeStorageHelper from '@/components/Globals/CorgeeStorageHelper';
import type { PersonData } from '@/contexts/AuthContext';

// ============================================
// FUNCIONES NUEVAS (TypeScript/LocalStorage)
// ============================================

export const getDashboardFromLocalStorage = (projectId: number | null): number =>
{
  const list = validateListFromLocalStorageData(
    JSON.parse(localStorage.getItem('C2_currentDashboard') ?? '[]'),
  );
  if (list.length == 0) return 0;
  const found = list.find(item => item.projectId == projectId);
  return found?.dashboardId > 0 ? found.dashboardId : 0;
};

export const validateListFromLocalStorageData = (data: any) =>
{
  let list = [];
  if (data)
  {
    if (Array.isArray(data))
    {
      list = data;
    }
    else
    {
      list.push(data);
    }
  }

  return list;
};

export const setPeopleData = (data: PersonSecurityData) =>
{
  try
  {
    const dataJson: any = {
      isAdmin: data.isAdmin,
      isAdminProject: data.isAdminProject,
      canEdit: data.canEdit,
      canDelete: data.canDelete,
      canTemporary: data.canTemporary,
      isBeta: data.isBeta,
      ImageProfile: data.ImageProfile,
      External: data.External,
      ExternalLogin: data.ExternalLogin,
      SupportPermissions: data.SupportPermissions,
      EmailAddress: data.EmailAddress,
      PTOApprover: data.PTOApprover,
      HRApprover: data.HRApprover,
    };
    sessionStorage.setItem('C2_data', JSON.stringify(dataJson));
  }
  catch (e: unknown)
  {
    // ignore
  }
};

export const checkAdminPermissions = (): boolean =>
{
  try
  {
    const data: PersonSecurityData = JSON.parse(sessionStorage.getItem('C2_data') || '');
    return data.isAdmin;
  }
  catch (e)
  {
    return false;
  }
};

export const checkPTOApproverPermissions = (): boolean =>
{
  try
  {
    const data: PersonSecurityData = JSON.parse(sessionStorage.getItem('C2_data') || '');
    return data.PTOApprover;
  }
  catch (e)
  {
    return false;
  }
};

export const checkHRApproverPermissions = (): boolean =>
{
  try
  {
    const data: PersonSecurityData = JSON.parse(sessionStorage.getItem('C2_data') || '');
    return data.HRApprover;
  }
  catch (e)
  {
    return false;
  }
};

export const getPersonData = (): PersonData | any =>
{
  try
  {
    const data: PersonData = JSON.parse(sessionStorage.getItem('C2_data') || '');
    return data;
  }
  catch (e)
  {
    return null;
  }
};

export const checkEditPermissions = (): boolean =>
{
  try
  {
    const data = JSON.parse(sessionStorage.getItem('C2_data') || '');
    // The API may return canEdit as boolean or as "true"/"false"/"1"/"0" strings
    const value = String(data.canEdit).toLowerCase();
    return value === 'true' || value === '1';
  }
  catch (e)
  {
    return false;
  }
};

export const setSideMenuLocal = (arraySideMenu: SideMenu[] | null): void =>
{
  sessionStorage.setItem('C2_sideMenuItems', JSON.stringify(arraySideMenu));
};

export const getSideMenuLocal = (): SideMenu[] | null =>
{
  return JSON.parse(sessionStorage.getItem('C2_sideMenuItems') ?? '[]');
};

/**
 * Returns the ConfigValueID for Bookmarks by reading C2_sideMenuItems from sessionStorage.
 * Falls back to 148 if the item is not found.
 */
export const getBookmarksConfigValueId = (): number =>
{
  try
  {
    const items: Array<{ Name: string; ConfigValueID: number }> = JSON.parse(
      sessionStorage.getItem('C2_sideMenuItems') ?? '[]',
    );
    const bookmarksItem = items.find(item => item.Name === 'Bookmarks');
    return bookmarksItem?.ConfigValueID ?? 148;
  }
  catch
  {
    return 148;
  }
};

export const getPersonId = (): number =>
{
  return Number(JSON.parse(localStorage.getItem('C2_personid') || ''));
};

export const getLayersToHide = (): number[] =>
{
  return JSON.parse(localStorage.getItem('C2_hiddenLayers') || '');
};

export const getDateActual = (): string =>
{
  const date = new Date();
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  return `${month}/${day}/${year}`;
};

// ============================================
// FUNCIONES VIEJAS (jQuery/Legacy)
// ============================================

export function isSafari()
{
  const isSafari =
    navigator.appVersion.search('Safari') != -1 &&
    navigator.appVersion.search('Chrome') == -1 &&
    navigator.appVersion.search('CrMo') == -1 &&
    navigator.appVersion.search('CriOS') == -1;
  return isSafari;
}

export function isFirefox()
{
  const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1 ? true : false;
  return isFirefox;
}

export function dropDownFixPosition(button: any, dropdown: any, showRight: any, pixelsLeft: any)
{
  let dropDownTop = button.offset().top + button.outerHeight() - ($('body.core2').scrollTop() ?? 0);

  let posLeft = 0;
  if (pixelsLeft)
  {
    posLeft = button.offset().left - pixelsLeft;
  }
  else
  {
    posLeft = button.offset().left;
  }

  dropdown.addClass('positionFixed');
  if (showRight)
  {
    dropDownTop = button.offset().top - ($('body.core2').scrollTop() ?? 0);
    posLeft += button.outerWidth();
  }
  dropdown.css('top', dropDownTop + 'px');
  dropdown.css('left', posLeft + 'px');
}

export function setDropdownMenuPosition(button: any)
{
  const dropdownMenuPosition = getDropdownMenuPosition(button);

  if (
    dropdownMenuPosition &&
    dropdownMenuPosition.dropdown &&
    dropdownMenuPosition.dropdown.length > 0
  )
  {
    dropdownMenuPosition.dropdown.css({
      top: dropdownMenuPosition.top,
      left: dropdownMenuPosition.left,
    });
  }
}

export function getDropdownMenuPosition(button: any)
{
  // Handle jQuery objects - extract native DOM element
  let nativeButton = button;
  if (button && typeof button.get === 'function')
  {
    nativeButton = button.get(0) || button[0];
  }
  else if (button && button[0] && button[0].nodeType)
  {
    nativeButton = button[0];
  }

  if (!nativeButton || !nativeButton.getBoundingClientRect)
  {
    return { top: 0, left: 0, dropdown: null };
  }

  // Support both tabs and card menu classes
  let actionMenuContainer = nativeButton.closest('.corgee_com_card-action-menu-group-tabs');
  let isTabs = true;

  if (!actionMenuContainer || actionMenuContainer.length === 0)
  {
    // Fallback to card menu class
    actionMenuContainer = nativeButton.closest('.corgee_com_card-action-menu-group');
    isTabs = false;
  }

  if (!actionMenuContainer)
  {
    // Return position based on button if container not found
    const rect = nativeButton.getBoundingClientRect();
    return {
      top: rect.top + rect.height + window.scrollY,
      left: rect.left,
      dropdown: null,
    };
  }

  // Find dropdown menu
  let dropdown = null;
  if (isTabs)
  {
    dropdown = actionMenuContainer.querySelectorAll?.(
      '.corgee_com_card-action-header-menu-tabs',
    )[0];
    if (!dropdown)
    {
      dropdown = document.querySelectorAll('.corgee_com_card-action-header-menu-tabs')[0];
    }
  }
  else
  {
    dropdown = document.querySelectorAll('.corgee_com_card-action-header-menu')[0];
  }

  // If still no dropdown, try generic dropdown-menu
  if (!dropdown)
  {
    dropdown = document.querySelectorAll('.dropdown-menu')[0];
  }

  let newTopPosition = 0,
    newLeftPosition = 0;

  const windowH = window.innerHeight,
    windowW = window.innerWidth;

  // Use getBoundingClientRect for accurate positioning
  const buttonRect = nativeButton.getBoundingClientRect();
  const dropdownW = dropdown?.offsetWidth || 200;
  const dropdownH = dropdown?.offsetHeight || 300;

  // Position below button by default
  if (buttonRect.top <= windowH / 2)
  {
    // Button is in top half - show menu below
    newTopPosition = buttonRect.top + buttonRect.height;
  }
  else
  {
    // Button is in bottom half - show menu above
    newTopPosition = buttonRect.top - dropdownH;
  }

  // Position left aligned with button
  if (buttonRect.left > windowW - dropdownW)
  {
    // Not enough space on right - align to right edge
    newLeftPosition = buttonRect.left + buttonRect.width - dropdownW;
  }
  else
  {
    newLeftPosition = buttonRect.left;
  }

  return {
    top: newTopPosition,
    left: newLeftPosition,
    dropdown: dropdown,
  };
}

export function getDropdownMenuPhasePosition(button: any)
{
  const actionMenuContainer = button.closest('.corgee_com_card-action-menu-group-tabs').first();

  let dropdown = actionMenuContainer.find('.dropdown-menu').first();

  if (!dropdown || dropdown.length == 0)
  {
    dropdown = $('.corgee_com_card-action-header-menu.dropdown-menu').first();
  }

  let newTopPosition = 0,
    newLeftPosition = 0;

  const item = button,
    windowH = window.innerHeight,
    windowW = window.innerWidth;

  const dropdownW = dropdown.outerWidth();
  const data = button.get(0).getBoundingClientRect();
  if (data.top <= windowH / 2)
  {
    newTopPosition = item.offset().top - window.scrollY;
  }
  else
  {
    newTopPosition = item.offset().top - dropdown.outerHeight() - window.scrollY;
  }

  if (item.offset().left > windowW - dropdownW)
  {
    newLeftPosition = item.offset().left - dropdownW;
  }
  else
  {
    newLeftPosition = item.offset().left;
  }
  newLeftPosition = newLeftPosition + 8;

  return {
    top: newTopPosition,
    left: newLeftPosition,
    dropdown: dropdown,
  };
}

export function showSeeMoreContent(body: any, createdBy: any)
{
  let showSeeMoreContent = false;
  if (body !== undefined && body !== null && body.trim() !== '')
  {
    // Use regex-based check to avoid creating DOM elements that would trigger image loading
    // Strip HTML tags to get text content
    const textContent = body.replace(/<[^>]*>/g, '').trim();
    // Check for img tags using regex (doesn't trigger image loading like jQuery would)
    const hasImages = /<img\s/i.test(body);
    const hasNonEmptyContent = textContent.length > 0 || hasImages;

    if (
      hasNonEmptyContent &&
      (body.indexOf('<div class="detail-update-embed') !== 0 || createdBy !== 'admin')
    )
    {
      showSeeMoreContent = true;
    }
  }
  return showSeeMoreContent;
}

export function getBodyValidated(item: any, isReply = false)
{
  let htmlBody = '<p><br></p>';

  if (!item.Body)
  {
    // Handle empty body
    let canEditAction = false;
    if (isReply === true)
    {
      canEditAction = replyHasEditPermissions(item);
    }
    else
    {
      canEditAction = convHasEditPermissions(item, null);
    }
    if (canEditAction)
    {
      return '<div class="update-body-hover"><p title="Double click to update"></p></div>';
    }
    return '<div><p></p></div>';
  }

  const isTemporaryReply = item.Body.indexOf('appendMovingDots') !== -1;

  // Use regex-based parsing to avoid jQuery creating DOM elements that trigger image loading
  const textContent = item.Body.replace(/<[^>]*>/g, '').trim();
  const hasImages = /<img\s/i.test(item.Body);
  const hasContent = textContent.length > 0 || hasImages;

  // Check if body has valid content
  if (
    hasContent ||
    (item.Attachments && item.Attachments.length > 0) ||
    item.ConfigValueId == 15 ||
    isTemporaryReply
  )
  {
    htmlBody = item.Body;

    // Handle images: fix protocol-relative URLs and add onerror handler
    if (htmlBody && htmlBody.indexOf('<img') > -1)
    {
      htmlBody = htmlBody.replace(/<img([^>]*)>/gi, (_match, attrs) =>
      {
        let newAttrs = attrs;

        // Fix protocol-relative URLs (//domain.com -> https://domain.com)
        newAttrs = newAttrs.replace(/src\s*=\s*["']\/\//gi, 'src="https://');

        // Add loading="lazy" if not present
        if (newAttrs.toLowerCase().indexOf('loading=') === -1)
        {
          newAttrs += ' loading="lazy"';
        }

        // Add onerror handler to hide broken images (only if not present)
        if (newAttrs.toLowerCase().indexOf('onerror') === -1)
        {
          newAttrs += ` onerror="this.style.display='none';this.onerror=null;"`;
        }

        return `<img${newAttrs}>`;
      });
    }
  }
  else
  {
    let canEditAction = false;
    if (isReply === true)
    {
      canEditAction = replyHasEditPermissions(item);
    }
    else
    {
      canEditAction = convHasEditPermissions(item, null);
    }

    if (canEditAction)
    {
      htmlBody = '<div class="update-body-hover"><p title="Double click to update"></p></div>';
    }
    else
    {
      htmlBody = '<div><p></p></div>';
    }
  }
  return htmlBody;
}

export function canEditEditDetailHistory(conversation: any)
{
  let canEdit = false;
  if (CorgeeStorageHelper.canEdit() || conversation.OwnedById === CorgeeStorageHelper.personId())
  {
    canEdit = true;
  }
  return canEdit;
}

export function convHasEditPermissions(conversation: any, reply: any)
{
  let canEditAction = false;
  if (conversation)
  {
    if (
      conversation.ConfigValueId === 9 &&
      conversation.OwnedById === CorgeeStorageHelper.personId()
    )
    {
      if (CorgeeStorageHelper.canEdit())
      {
        canEditAction = true;
      }
    }
    else
    {
      if (
        CorgeeStorageHelper.canEdit() &&
        conversation.OwnedById === CorgeeStorageHelper.personId()
      )
      {
        canEditAction = true;
      }
    }

    if (CorgeeStorageHelper.isAdmin())
    {
      canEditAction = true;
    }
    if (conversation.ConfigValueId === 15 || conversation.IsEnable === false)
    {
      canEditAction = false;
    }
  }
  else if (reply)
  {
    if (CorgeeStorageHelper.canEdit() && reply.CreatedById === CorgeeStorageHelper.personId())
    {
      canEditAction = true;
    }
    if (CorgeeStorageHelper.isAdmin())
    {
      canEditAction = true;
    }
  }

  return canEditAction;
}

export function convHasTitleEditPermissions(conversation: any): boolean
{
  if (!conversation) return false;
  if (conversation.ConfigValueId === 15 || conversation.IsEnable === false) return false;
  if (CorgeeStorageHelper.isAdmin()) return true;

  const personId = CorgeeStorageHelper.personId();
  const createdById = conversation.CreatedByID ?? conversation.CreatedById ?? 0;

  if (
    CorgeeStorageHelper.canEdit() &&
    (createdById === personId ||
      conversation.OwnedById === personId ||
      conversation.ConfigValueId === 9)
  )
  {
    return true;
  }

  return false;
}

export function convHasDeletePermissions(conversation: any)
{
  let canDeleteAction = false;
  if (conversation && conversation.ConfigValueId !== 15)
  {
    if (
      CorgeeStorageHelper.canDelete() &&
      conversation.OwnedById === CorgeeStorageHelper.personId()
    )
    {
      canDeleteAction = true;
    }
    if (CorgeeStorageHelper.isAdmin())
    {
      canDeleteAction = true;
    }
  }
  return canDeleteAction;
}

export function replyHasEditPermissions(reply: any)
{
  let canEditAction = false;
  if (reply)
  {
    if (
      CorgeeStorageHelper.canEdit() &&
      (reply.CreatedByID === CorgeeStorageHelper.personId() ||
        reply.CreatedById === CorgeeStorageHelper.personId())
    )
    {
      canEditAction = true;
    }
    if (CorgeeStorageHelper.isAdmin())
    {
      canEditAction = true;
    }
    if (reply.IsEnable === false)
    {
      canEditAction = false;
    }
  }
  return canEditAction;
}

export function replyHasEditPermissionsTemporary(reply: any)
{
  let canTemporaryAction = false;
  if (reply)
  {
    if (
      !CorgeeStorageHelper.canEdit() &&
      !CorgeeStorageHelper.isAdmin() &&
      CorgeeStorageHelper.canTemporary() &&
      reply.CreatedById === CorgeeStorageHelper.personId()
    )
    {
      const dateNow = new Date();
      const dateReply = new Date(reply.CreatedAt);
      const diffMs = dateNow.getTime() - dateReply.getTime();
      const diffDays = Math.round(diffMs / 86400000);
      const diffHrs = Math.round((diffMs % 86400000) / 3600000);
      const diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000);
      if (diffDays == 0 && diffHrs == 0 && diffMins < 16)
      {
        canTemporaryAction = true;
      }
    }

    if (reply.IsEnable === false)
    {
      canTemporaryAction = false;
    }
  }
  return canTemporaryAction;
}

export function replyHasDeletePermissions(reply: any)
{
  let canDeleteAction = false;
  if (reply)
  {
    if (
      CorgeeStorageHelper.canDelete() &&
      (reply.CreatedByID === CorgeeStorageHelper.personId() ||
        reply.CreatedById === CorgeeStorageHelper.personId())
    )
    {
      canDeleteAction = true;
    }
    if (CorgeeStorageHelper.isAdmin())
    {
      canDeleteAction = true;
    }
    if (reply.IsEnable === false)
    {
      canDeleteAction = false;
    }
  }
  return canDeleteAction;
}

export function getMomentDateTime(dateTimeValue: any)
{
  if (!dateTimeValue) return '';
  return moment(dateTimeValue).fromNow();
}

export function applyFormatDate(dateTimeValue: any, formatDate: any)
{
  if (!dateTimeValue) return '';
  return moment(dateTimeValue).format(formatDate);
}

export function getImageExtensions()
{
  return ['.jpg', '.jpe', '.bmp', '.gif', '.png', '.jpeg', '.webp'];
}

export function extInImageExtensions(extension: any)
{
  const a = getImageExtensions().indexOf(extension);
  if (a >= 0)
  {
    return true;
  }
  else
  {
    return false;
  }
}

export function getDocumentClassName(docType: any)
{
  switch (docType)
  {
    case '.pdf':
      return 'Pdf';
    case '.doc':
    case '.docx':
      return 'Doc';
    case '.xls':
    case '.xlsx':
      return 'Xls';
    case '.zip':
      return 'Zip';
    case '.rar':
      return 'Rar';
    case '.ppt':
    case '.pptx':
      return 'Ppt';
    case '.psd':
    case '.psb':
      return 'Psd';
    case '.ai':
    case '.svg':
      return 'Ai';
    case '.pur':
      return 'Pur';
    case '.3gp':
    case '.mp4':
    case '.mov':
    case '.ogg':
    case '.webm':
    case '.f4v':
    case '.m4v':
    case '.mkv':
      return 'Vid';
    default:
      return 'Def';
  }
}

export function inArray(arr: any, itemValue: any)
{
  if (arr)
  {
    const result = arr.findIndex(function (itemArr: any)
    {
      return itemArr === itemValue;
    });
    if (result != -1)
    {
      return true;
    }
    else
    {
      return false;
    }
  }
  else
  {
    return false;
  }
}

/**
 * Extracts the personId from a "Users" notification body.
 * The body contains: <a id='labela' href='.../#/Person/Authorize/1234'>...</a>
 */
export function extractPersonIdFromNotification(body: string): number | null
{
  const parser = new DOMParser();
  const doc = parser.parseFromString(body, 'text/html');
  const link = doc.querySelector('#labela') as HTMLAnchorElement | null;
  if (!link) return null;
  const match = (link.getAttribute('href') ?? '').match(/\/Person\/Authorize\/(\d+)/);
  return match ? parseInt(match[1]!, 10) : null;
}
